import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from "@/api/PMS/placeAreaPrice/placeAreaPrice";
import waves from "@/directive/waves"; // 水波纹指令

export default {
  name: "ComplexTable",
  props: ["keyValue", "showDialog", "periodIdList"],
  directives: {
    waves: waves
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  data: function data() {
    return {
      multipleSelection: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        // limit: 10,
        areaId: ""
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handCancle: function handCancle() {
      this.$emit("handCancle");
    },
    handCreate: function handCreate() {
      this.$emit("handCreate", this.multipleSelection);
    },
    // rowclick(row, column, event) {
    //   this.$emit("handCancle", true, row);
    // },
    init: function init() {
      this.listQuery = {
        page: 1 // limit: 10

      };
      this.total = null;
      this.getList();
    },
    toggleSelection: function toggleSelection(rows) {
      var _this = this;

      if (rows) {
        rows.forEach(function (row) {
          _this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      this.listQuery.areaId = this.keyValue;
      fetchList(this.listQuery).then(function (response) {
        _this2.list = response.data.data;

        _this2.$nextTick(function () {
          if (_this2.$refs.multipleTable) {
            // 清空所有选中状态
            _this2.$refs.multipleTable.clearSelection();

            var multipleSelection = [];

            for (var key in _this2.list) {
              if (_this2.periodIdList.indexOf(_this2.list[key]["id"]) !== -1) {
                _this2.$refs.multipleTable.toggleRowSelection(_this2.list[key], true);

                multipleSelection.push(_this2.list[key]);
              }
            }

            _this2.multipleSelection = multipleSelection;
          }
        });

        _this2.total = response.data.total;
        _this2.listLoading = false;
      });
    } // handleFilter() {
    //   this.listQuery.page = 1;
    //   this.getList();
    // }
    // handleSizeChange(val) {
    //   this.listQuery.limit = val;
    //   this.getList();
    // },
    // handleCurrentChange(val) {
    //   this.listQuery.page = val;
    //   this.getList();
    // }

  }
};